import { html } from '@resn/gozer-core';

import { Component, componentMixin } from '@resn/gozer-core/component';
import DomComponentMixin from '@resn/gozer-core-mixins/dom-component';
import SectionMixin from 'component/sections/base/section-mixin';
import SectionFallbackMixin from 'component/sections/base/section-fallback-mixin';
import AssetsMixin from 'utils/loading/assets-mixin';
import gsap from 'gsap';

import Copy from '@resn/gozer-core/copy';
import Svg from 'component/svg';
import { autobind } from 'core-decorators';
import { deviceBenchmark } from 'utils/device-benchmark';
import { getRoute } from 'utils/get-pages';
import { COLORS, LINKS } from 'core/constants';
import { map } from '@resn/gozer-math';
import { isMobile } from '@resn/gozer-env';

import BtnMain from 'component/btn-main';
import Scene from './scene';

import getStore from 'core/store';
const store = getStore();

import './index.scss';
import ScrollArrows from 'component/scroll-arrows';
import { navigate } from 'utils/router-utils';
import { easings } from '@resn/gozer-animation';
import { lerp } from '@resn/gozer-math';
import Renderer from 'component/gl/renderer';
import { Color } from 'three';
import picture from 'utils/picture';
import env from 'core/env';

const template = ({ options, context }) => html`
    <section class="section  homeHero${context.hasIntro ? ' homeHero--hasIntro' : ''}  inverseColors">
        <!-- <div data-ui="arrowWrap" class="homeHero__arrowWrap"></div> -->
        <div data-ui="inner" class="homeHero__inner  grid  maxWidth">

            <div data-ui="imgWrap" class="homeHero__imgWrap">
                ${picture({
                    src: options.srcHero,
                    // fit: isMobile ? 'contain' : 'cover',
                    // position: isMobile ? 'top' : 'center',
                    className: 'homeHero__img',
                })}
            </div>

            <div data-ui="intro" class="homeHero__intro"></div>

            <div data-ui="content" class="homeHero__content">
                <h2 data-ui="pretitle" class="homeHero__subtitle  text-heading6">
                    ${Copy.get('home-hero-intro-title')}
                </h1>
                <h1 data-ui="logo" class="homeHero__title">
                    XP1
                    ${Svg('xp1-logo', 'homeHero__xp1Logo')}
                </h1>
                <p data-ui="body" class="homeHero__body  text-body2">${Copy.get('home-hero-intro-paragraph')}</p>
                
                <div data-ui="btnWrap" class="homeHero__btnWrap"></div>
            </div>

        </div>
    </section>
`;

@componentMixin(AssetsMixin('home-hero'))
@componentMixin(DomComponentMixin)
@componentMixin(deviceBenchmark.fallback ? SectionFallbackMixin : SectionMixin)
class HomeHero extends Component {
    props = {
        animate: false,
        // animateIntro: false,
        intro: false,
    };

    options = {
        template,
        srcHero: `${env.CDN}static/images/pages/home/hero-xp1.png`,
    };

    assets = {
        // arrowGradient: 'static/images/pages/home/home-hero-arrow-gradient.svg#img',
        // triangle: 'static/images/pages/home/triangle-down.svg#img',
        // hero: 'static/images/pages/home/hero-xp1.png#imgo',
    };

    clearColor = new Color('white');

    onAssetsPreloaderComplete() {
        // const img = this.assets.hero.cloneNode();
        // img.classList.add('homeHero__img');
        // this.ui.imgWrap.appendChild(img);
        // this.props.intro = true;
        // if (!deviceBenchmark.fallback) return;
        // this.triangle = this.assets.triangle;
        // this.triangle.classList.add('homeHero__topTriangle');
        // this.ui.arrowWrap.appendChild(this.triangle);
        // this.arrow = this.assets.arrowGradient;
        // this.arrow.classList.add('homeHero__arrowGradient');
        // this.ui.arrowWrap.appendChild(this.arrow);
        // this.fallbackEls = [this.triangle, this.arrow];
        // // this.elements.unshift(this.triangle, this.arrow);
    }

    async onSetup() {
        this.elements = [];

        // await this.preload();

        this.btnExperience = await new BtnMain().setup({
            options: {
                appendTo: this.ui.btnWrap,
                rolloverGradient: [COLORS.LIGHT_BLUE_2, COLORS.ORANGE],
                onClick: () => {
                    window.open(LINKS.OXEFIT_EXPERIENCE, '_blank');
                },
            },
            props: {
                text: Copy.get('home-hero-experience-button'),
                textColor: 'white',
                bgColor: COLORS.DARK_BLUE,
            },
        });

        this.btn = await new BtnMain().setup({
            options: {
                appendTo: this.ui.btnWrap,
                className: 'exploreBtn',
                rolloverGradient: [COLORS.LIGHT_BLUE_2, COLORS.ORANGE],
                onClick: this.onExploreXP1Click,
            },
            props: {
                text: Copy.get('home-hero-intro-button'),
                iconId: 'external-link',
                textColor: 'white',
                bgColor: COLORS.ORANGE,
            },
        });

        this.elements.push(this.ui.imgWrap, this.ui.btnWrap, this.ui.body, this.ui.logo, this.ui.pretitle);

        // if (!deviceBenchmark.fallback) await this.setupScene();

        // this.setupIntro();
        this.initStyles();
    }

    initStyles() {
        if (this.introElements) gsap.set(this.introElements, { alpha: 0, willChange: 'transform' });
        // if (this.fallbackEls) gsap.set(this.fallbackEls, { alpha: 0, y: '-100%', willChange: 'transform' });
        gsap.set(this.elements, { alpha: 0, willChange: 'transform' });
        // gsap.set(this.ui.imgWrap, { alpha: 1 });
    }

    async setupScene() {
        this.scene = await new Scene().setup({
            options: {
                ui: this.ui,
                bgColor: COLORS.OFF_WHITE,
                useRendererBatch: isMobile,
            },
            props: {
                t: () => this.props.t,
                pX: () => this.props.x,
                scrollProgress: () => this.props.scrollProgress,
                scroll: () => this.props.scroll,

                translation: [150, -20],
                height: 1300,

                bounds: () => this.props.bounds,
                viewport: () => this.props.viewport,
                scale: () => this.props.scale,
                mobile: () => this.props.mobile,

                active: false,
                loaded: () => this.props.loaded,
            },
        });
    }

    onActive() {
        // this.props.animate = true;
        this.props.intro = true;
    }

    offActive() {
        if (this.showDelay) this.showDelay.kill();
    }

    onIntro() {
        const { scale } = store.state;

        if (this.ui.intro) gsap.set(this.ui.intro, { alpha: 0 });
        this.props.animate = true;
    }

    onAnimate() {
        const { mobile, scale, route } = store.state;

        if (this.scene) this.scene.props.active = true;

        if (route.first) {
            const yFrom = (mobile ? -100 : 80) * scale;
            const delay = mobile ? 0.23 : 0.1;
            const imgDur = mobile ? 0.3 : 0.4;
            const elDur = mobile ? 2 : 3;

            gsap.to(this.elements, { alpha: 1, duration: 1, delay, stagger: 0.06 });
            gsap.killTweensOf(this.ui.imgWrap);
            gsap.to(this.ui.imgWrap, { alpha: 1, duration: imgDur, delay, ease: 'sine.in' });
            gsap.fromTo(this.elements, { y: yFrom }, { y: 0, duration: elDur, delay, stagger: 0.06, ease: 'expo.out' });

            // if (deviceBenchmark.fallback) {
            //     gsap.to(this.fallbackEls, {
            //         y: 0,
            //         duration: 3,
            //         ease: 'expo.out',
            //         stagger: 0.05,
            //     });
            //     gsap.to(this.fallbackEls, {
            //         alpha: 1,
            //         duration: 1,
            //         ease: 'sine.inOut',
            //         stagger: 0.05,
            //     });
            // }
        } else {
            gsap.set(this.ui.imgWrap, { alpha: 1 });
            gsap.set(this.elements, { alpha: 1, y: 0 });
        }
    }

    @autobind
    onExploreXP1Click() {
        navigate(getRoute('xp1'));
    }

    resize() {
        // if (this.scene) this.scene.resize();
    }

    update() {
        const { mobile, scale } = store.state;
        const { scroll, bounds, viewport } = this.props;

        if (this.scene) {
            this.scene.props.pYOffset = this.y;
            this.scene.update();
        }

        if (mobile || deviceBenchmark.fallback) return;

        const yDist = 1200 * scale;
        const yPr = map(
            scroll,
            bounds.top - viewport.height - 1000 * scale,
            bounds.top - viewport.height + bounds.height,
            0,
            1,
            true,
        );

        const y = lerp(easings.easeOutSine(yPr), -yDist, 0);

        this.ui.inner.style.transform = `translateY(${y}px)`;
    }

    // render() {
    //     if (this.scene) this.scene.render();
    // }

    onDestroy() {
        if (this.showDelay) this.showDelay.kill();
    }
}

export default HomeHero;
